module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.0ffd27b565fdf9f7d41c.js");
};